export default __webpack_public_path__ + "static/media/aiSecurityRealcase-en.8f658a25.jpg";